<template>
	<vx-card no-shadow>
		<vs-input
			id="file-upload"
			type="file"
			v-validate="'required'"
			class="mt-3 w-full mb-4"
			@change="onFileChange"
		/>

		<div class="custom-file-upload" for="file-upload">
			<label class="custom-file-upload__icon" :class="uploadStatus">
				<feather-icon class="cursor-pointer mr-2" icon="UploadCloudIcon" svgClasses="h-8 w-8" />
			</label>
			<label class="custom-file-upload__text" :class="uploadStatus">
				{{ this.fileName }}
			</label>
		</div>

		<p>{{ $t("Zonification.UploadZones.SelectFileText") }}</p>

		<div class="mt-4">
			<vs-progress :height="12" :percent="percent" :color="progressColor"></vs-progress>
		</div>

		<vs-button
			id="btn-save-visit-point"
			class="ml-auto mt-4 vs-con-loading__container"
			@click.prevent="uploadFile"
			:disabled="!dataFile"
			>{{ $t("Upload") }}
		</vs-button>
	</vx-card>
</template>

<script>
import firebase from "firebase/app";
import "firebase/storage";
import {uploadFileToFirebase} from "@/helpers/firebaseDB.js";

export default {
	data() {
		return {
			storageRef: firebase.storage(),
			percent: 0,
			dataFile: null,
			fileName: this.$t("Zonification.UploadZones.FileName"),
			textStatus: "",
			progressColor: "success",
		};
	},
	computed: {
		uploadStatus() {
			if (this.textStatus === "success") return "text-success";
			else if (this.textStatus === "error") return "text-danger";
			else return "";
		},
	},
	methods: {
		successUpload() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Zonification.UploadZones.Success.Title"),
				text: this.$t("Zonification.UploadZones.Success.Text"),
			});
		},
		errorUploadNotify(message) {
			this.$vs.notify({
				color: "danger",
				title: this.$t("Zonification.UploadZones.Error.Title"),
				text: message,
			});
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.fileName = this.dataFile.name;
			this.percent = 0;
			this.textStatus = "success";
			this.progressColor = "success";
		},
		uploadFile() {
			if (!this.dataFile) {
				return;
			}
			const path = "/uploads/layer/";
			uploadFileToFirebase
				.call(this, this.dataFile, path)
				.then((res) => {
					this.fileName = this.$t("Zonification.UploadZones.FileName");
					this.dataFile = null;
					this.textStatus = "";
					this.successUpload();
				})
				.catch((error) => {
					this.textStatus = "error";
					this.progressColor = "danger";
					this.handleUploadError(error);
				});
		},
		handleUploadError(error) {
			switch (error.code) {
				case "storage/unauthorized":
					// User doesn't have permission to access the object
					this.errorUploadNotify(this.$t("Zonification.UploadZones.Error.Permission"));
					break;
				case "storage/canceled":
					// User canceled the upload
					this.errorUploadNotify(this.$t("Zonification.UploadZones.Error.Cancel"));
					break;
				case "storage/unknown":
					// Unknown error occurred, inspect error.serverResponse
					// "Ocurrió un error inesperado durante la carga del archivo"
					this.errorUploadNotify(this.$t("Zonification.UploadZones.Error.Unknown"));
					break;
			}
		},
	},
};
</script>

<style lang="css" scope>
input[type="file"] {
	display: none;
}

.custom-file-upload {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid #f3f3f3;
	border-radius: 5px;
}

.custom-file-upload:hover {
	border: 1px solid #979797;
}

.custom-file-upload__icon {
	padding: 50px 100% 0px 100%;
}

.custom-file-upload__text {
	padding: 0px 50px 50px 50px;
}
</style>
